<h1 mat-dialog-title>{{ 'executionEdit.instrumentationUse.title' | translate }}</h1>

<div mat-dialog-content class="qualificates-theme" fxLayout="column">
  <div fxFlex="100">
    <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" required
      [(ngModel)]="data.data.idInstrumentation" name="idInstrumentation"
      (change)="onInstrumentationChange($event)">
      @for (item of instrumentationUse; track item) {
        <mat-radio-button [value]="item.id">
          {{ 'instrumentation.' + item.translation | translate }}
          <!--<button mat-icon-button (click)="editValidator()" *ngIf="canEditValidator(item)"
          matTooltip="{{ 'button.edit' | translate }}">
          <mat-icon>mode_edit</mat-icon>
        </button>-->
      </mat-radio-button>
    }
  </mat-radio-group>
</div>

<div fxFlex="100">
  @if (showValidator()) {
    <table style="width:100%;" class="tablaConBordes">
      <tr>
        <th>{{ 'protocolEdit.instrumentationUse.validator.calibrationPoint' | translate }}</th>
        <th>{{ 'protocolEdit.instrumentationUse.validator.valueTemp' | translate }}</th>
        <th>{{ 'protocolEdit.instrumentationUse.validator.maxDeviation' | translate }}</th>
        <th>{{ 'protocolEdit.instrumentationUse.validator.minStability' | translate }}</th>
      </tr>
      <tr>
        <td>{{ 'protocolEdit.instrumentationUse.validator.lowTemp' | translate }}</td>
        <td>
          <mat-form-field class="campoFormulario" style="width: 3em">
            <input matInput [(ngModel)]="data.data.validator.lowTemp" name="lowTemp"
              required [errorStateMatcher]="matcher" size="3">
          </mat-form-field>
        </td>
        <td>
          ≤
          <mat-form-field class="campoFormulario" style="width: 3em">
            <input matInput [(ngModel)]="data.data.validator.lowDesv" name="lowDesv"
              required [errorStateMatcher]="matcher" size="3">
          </mat-form-field>
          {{ 'protocolEdit.instrumentationUse.validator.aboutRefTemp' | translate }}
        </td>
        <td>{{ 'protocolEdit.instrumentationUse.validator.notApplicable' | translate }}</td>
      </tr>
      <tr>
        <td>{{ 'protocolEdit.instrumentationUse.validator.highTemp' | translate }}</td>
        <td>
          <mat-form-field class="campoFormulario" style="width: 3em">
            <input matInput [(ngModel)]="data.data.validator.highTemp" name="highTemp"
              required [errorStateMatcher]="matcher" size="3">
          </mat-form-field>
        </td>
        <td>
          ≤
          <mat-form-field class="campoFormulario" style="width: 3em">
            <input matInput [(ngModel)]="data.data.validator.highDesv" name="highDesv"
              required [errorStateMatcher]="matcher" size="3">
          </mat-form-field>
          {{ 'protocolEdit.instrumentationUse.validator.aboutRefTemp' | translate }}
        </td>
        <td>{{ 'protocolEdit.instrumentationUse.validator.notApplicable' | translate }}</td>
      </tr>
      <tr>
        <td>{{ 'protocolEdit.instrumentationUse.validator.verifTemp' | translate }}</td>
        <td>
          <mat-form-field class="campoFormulario" style="width: 3em">
            <input matInput [(ngModel)]="data.data.validator.verifTemp" name="verifTemp"
              required [errorStateMatcher]="matcher" size="3">
          </mat-form-field>
        </td>
        <td>
          ±
          <mat-form-field class="campoFormulario" style="width: 3em">
            <input matInput [(ngModel)]="data.data.validator.verifDesv" name="verifDesv"
              required [errorStateMatcher]="matcher" size="3">
          </mat-form-field>
          {{ 'protocolEdit.instrumentationUse.validator.aboutRefTemp' | translate }}
        </td>
        <td>
          <mat-form-field class="campoFormulario" style="width: 3em">
            <input matInput [(ngModel)]="data.data.validator.minStability"
              name="minStability" required [errorStateMatcher]="matcher" size="3">
          </mat-form-field>
          {{ 'protocolEdit.instrumentationUse.validator.tempIn' | translate }}
          <mat-form-field class="campoFormulario" style="width: 3em">
            <input matInput [(ngModel)]="data.data.validator.minStabilityTime"
              name="minStabilityTime" required [errorStateMatcher]="matcher" size="3">
          </mat-form-field>
          {{ 'protocolEdit.instrumentationUse.validator.minutes' | translate }}
        </td>
      </tr>
    </table>
  }
</div>

</div>
<div mat-dialog-actions align="end" class="qualificates-theme">
  <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>